import {gql, useLazyQuery} from '@apollo/client'
import {useSelector} from 'react-redux'
import paginationLimit from '../configs/paginationLimit.json'

export const GET_SAVED_PROSPECTS_LIST = gql`
  query GetSavedProspectsList(
    $searchTerm: String
    $startIndex: Int!
    $limit: Int!
    $azureRole: String
    $sortColumn: String
    $sortDirection: String
  ) {
    getSavedList(
      searchTerm: $searchTerm
      startIndex: $startIndex
      limit: $limit
      azureRole: $azureRole
      sortColumn: $sortColumn
      sortDirection: $sortDirection
    ) {
      totalCount
      savedLists {
        listName
        dateCreated
        dateUpdated
        totalConstituents
      }
    }
  }
`

export const useSavedProspectsList = () => {
  const currentPage = useSelector((state) => state.currentPageNumber.savedProspectsValue)
  const startIndex = (currentPage - 1) * paginationLimit.pagination.prospectsSegment
  const searchTerm = useSelector((state) => state.search.savedProspectsSearch)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const sortDirection = useSelector((state) => state.getAllProspectsData.sortDirection)
  const sortColumn = useSelector((state) => state.getAllProspectsData.sortColumn)
  const [conditionalSavedList, {data, loading, error, refetch}] = useLazyQuery(GET_SAVED_PROSPECTS_LIST, {
    variables: {
      searchTerm: searchTerm.currentTerm,
      startIndex,
      limit: paginationLimit.pagination.prospectsSegment,
      ...(azureRole ? {azureRole} : {}),
      ...(sortDirection ? {sortDirection} : {}),
      ...(sortColumn ? {sortColumn} : {})
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    fetchPolicy: 'network-only'
  })
  return [conditionalSavedList, {data, loading, error, refetch}]
}
